import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaRobot, FaBrain, FaEye, FaChartLine, FaComments, FaLightbulb, FaMicrochip, FaCogs, FaHeadset, FaUser } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const DataScienceAi = () => {
  return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>
      {/* Top Glassy Banner */}
      <Card
        sx={{
            background: "rgba(0, 0, 0, 0.9)",
            color: "white",
            borderRadius: "12px",
            padding: "30px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(15px)",
            textAlign: "center",
        }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Unleashing Tomorrow's Possibilities with Data Science & AI
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Transform your business landscape with AI-driven solutions! Leverage cutting-edge technologies to automate,
            optimize, and unlock new insights tailored to your unique needs.
          </Typography>
        </CardContent>
      </Card>

      {/* AI Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {aiServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      
      <OurNumbers/>
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Number Presentation
const statsBoxStyle = {
  borderRadius: "10px",
  padding: "20px",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  backdropFilter: "blur(12px)",
  textAlign: "center",
  minWidth: "200px",
};

const logoBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
    borderRadius: "10px",
    backgroundColor: "rgb(211, 154, 158, 0.08)",
    marginBottom: "15px",
    boxShadow: "0 0 5px rgb(211, 154, 158), 0 0 10px rgb(211, 154, 158), 0 0 20px rgb(211, 154, 158)",
    fontSize: "2rem", // Adjust the font size to make the icon larger
};

// Expanded AI Services with Hot AI Topics
const aiServices = [
  {
    title: "AI Driven Solutions",
    description: "Unlock new efficiencies with AI-driven automation and intelligent decision-making.",
    icon: <FaRobot />,
  },
  {
    title: "Machine Learning",
    description: "Deploy ML algorithms that enable systems to learn, adapt, and improve over time.",
    icon: <FaBrain />,
  },
  {
    title: "Computer Vision",
    description: "Empower machines to analyze and interpret visual data, revolutionizing industries.",
    icon: <FaEye />,
  },
  {
    title: "Predictive Modeling",
    description: "Anticipate trends and business outcomes with advanced predictive analytics.",
    icon: <FaChartLine />,
  },
  {
    title: "Natural Language Processing",
    description: "Enhance user experiences with AI-powered chatbots and text analysis solutions.",
    icon: <FaComments />,
  },
  {
    title: "Advanced Analytics",
    description: "Leverage data science to extract deep insights and optimize decision-making.",
    icon: <FaLightbulb />,
  },
  {
    title: "Generative AI",
    description: "Create unique content and enhance creativity with powerful Generative AI models.",
    icon: <FaMicrochip />,
  },
  {
    title: "AI Agents",
    description: "Develop AI-driven virtual assistants capable of executing complex workflows.",
    icon: <FaUser />,
  },
  {
    title: "Chatbot Creation",
    description: "Build interactive, intelligent chatbots to enhance customer engagement and support.",
    icon: <FaHeadset />,
  },
  {
    title: "AI in Automation",
    description: "Automate business processes and workflows using AI-powered automation tools.",
    icon: <FaCogs />,
  },
];

// Statistics with Stylish UX
const statistics = [
  { value: "100%", label: "Customer Satisfaction" },
  { value: "75+", label: "Projects Delivered" },
  { value: "5+", label: "Industries Served" },
];

export default DataScienceAi;